// routes.js
import Dashboard from "layouts/Dashboard";
import Users from "layouts/Users";
import Achievers from "layouts/Achievers";
import DailyURL from "layouts/DailyURL";
import Blogs from "layouts/Blogs";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";

import Icon from "@mui/material/Icon";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import FeedIcon from "@mui/icons-material/Feed";
import { Navigate } from "react-router-dom";

const isAuthenticated = localStorage.getItem("AdminUser");

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "Dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/Dashboard",
    component: isAuthenticated ? <Dashboard /> : <Navigate to="/authentication/sign-in" />,
  },
  {
    type: "collapse",
    name: "Users",
    key: "Users",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/Users",
    component: isAuthenticated ? <Users /> : <Navigate to="/authentication/sign-in" />,
  },
  {
    type: "collapse",
    name: "Achievers",
    key: "Achievers",
    icon: <EmojiEventsIcon fontSize="small" />,
    route: "/Achievers",
    component: isAuthenticated ? <Achievers /> : <Navigate to="/authentication/sign-in" />,
  },
  {
    type: "collapse",
    name: "Daily URL",
    key: "DailyURL",
    icon: <Icon fontSize="small">link</Icon>,
    route: "/DailyURL",
    component: isAuthenticated ? <DailyURL /> : <Navigate to="/authentication/sign-in" />,
  },
  {
    type: "collapse",
    name: "Blogs",
    key: "Blogs",
    icon: <FeedIcon fontSize="small" />,
    route: "/Blogs",
    component: isAuthenticated ? <Blogs /> : <Navigate to="/authentication/sign-in" />,
  },
  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
  {
    type: "collapse",
    name: "Sign Up",
    key: "sign-up",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/authentication/sign-up",
    component: isAuthenticated ? <SignUp /> : <Navigate to="/authentication/sign-in" />,
  },
];

export default routes;
